import React from 'react';

import Modal from 'react-bootstrap/Modal';

const AlertPopup = (props) => {
    return <Modal show={props.show} onHide={() => props.onHide()} className="alert">
        <Modal.Header closeButton>
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.alertText}</Modal.Body>
        <Modal.Footer>
            <button type="button" className="submit-btn" data-dismiss="modal" onClick={props.onHide}>{props.buttonText}</button>
        </Modal.Footer>
    </Modal>
}

export default AlertPopup
